<template>
  <div
    class="TNovoProjeto"
    data-testid="TNovoProjeto"
  >
    <div class="TNovoProjeto__Header">
      <slot name="titulo" />
    </div>

    <div class="TNovoProjeto__Main">
      <slot name="campos" />
    </div>
    <div class="TNovoProjeto__TabMenu">
      <slot name="tabmenu" />
    </div>
    <div class="TNovoProjeto__Centro">
      <slot name="centro" />
    </div>
    <div class="TNovoProjeto__Footer">
      <slot name="acoes" />
    </div>
    <div class="TNovoProjeto__Modais">
      <slot name="modais" />
    </div>
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
  @import "./TNovoProjeto.style.scss";
</style>
